module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国邮政局旧址.49bd0c4f.png";